import { StorageConfiguration } from "webshop-modules/storage/StorageConfiguration.interface";
import { App } from "vue";
import { StorageService } from "webshop-modules";

export class StoragePlugin {

    constructor(private configuration: StorageConfiguration) {
    }

    public install(app: App, options?: any): void {
        // Assign global $storageService property
        app.config.globalProperties[StorageService.identifier] = StorageService.getInstance(this.configuration);
    }

}
